<template>
  <div class="overflow-hidden modal">
    <!-- overlay -->
    <transition
      name="overlay"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <portal to="overlay">
        <div class="fixed pin z-20" v-if="isModalVisible">
          <div
            @click="hideModal()"
            class="absolute pin bg-black opacity-25"></div>
        </div>
      </portal>
    </transition>
    <!-- end overlay -->

    <transition
      name="paths"
      leave-active-class="animated fadeOut faster"
      enter-active-class="animated fadeIn faster"
    >

      <portal to="modal">
        <div v-if="isModalVisible"
          class="fixed pin flex modal overflow-auto z-40">
          <div
            class="relative bg-gray-lightest w-full flex-col flex overflow-auto p-8">

            <div class="container mx-auto">
              <div class="lg:w-1/2 m-auto">
                <div @click="hideModal()"
                  class="text-xs cursor-pointer underline text-full-blue"
                >Back</div>



                <div class="flex justify-between items-center pb-6">
                  <h2 class="text-2xl py-4 font-bold">Add Tag Filter</h2>
                </div>


                <div class="container">
                  <div class="pb-6">
                  <div class="pb-4 text-xs">Reaction Groups Quick Select</div>
                  <reaction-groups @select="hideModal()" />
                  </div>
                  <div v-if="tags.length" class="pb-2">
                    <div class="pb-4 text-xs">Selected Tags</div>
                    <div class="flex items-baseline flex-wrap">
                      <div
                        class="tag-tile text-lg font-mono pb-2 pt-3 px-2 bg-dark-teal text-white rounded-sm font-bold flex flex-col justify-between cursor-pointer"
                        @click.prevent="$emit('rmtag', t)"
                        v-for="t in tags">
                        <div class="w-full flex justify-end pb-2">
                          <font-awesome-icon size="sm" icon="times" />
                        </div>
                        <div
                          class="w-full tag-text text-white rounded font-bold flex items-center">
                          <span v-html="parsedSymbol('#' + t)"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="text-xs pb-4">No tags selected</div>
                  </div>
                  <div class="pb-8">
                    <div class="pb-4 text-xs">Choose tags</div>

                    <tag-list :filterList="tags" @select="$emit('addtag', $event)" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </portal>
    </transition>
  </div>
</template>

<script>
 import TagList from '@/components/TagList';
 import ReactionGroups from '@/components/ReactionGroups';
 export default {
   name: 'tag-modal',

   props: {
     tags: {
       type: Array
     },
     isModalVisible: {
       type: Boolean,
       default: true
     }
   },

   components: {
     TagList,
     ReactionGroups
   },

   methods: {
     hideModal (message) {
       this.$emit('close');
     },
     parsedSymbol (sym) {
       return twemoji.parse(sym)
     }
   },

 }

</script>


<style scoped>
 .tag-tile {
   width: 30%;
   margin-right: 5%;
   margin-bottom: 40px;
   min-height: 50px;
   align-self: stretch;
 }

 .tag-text {
   word-wrap: anywhere;
 }

 .tag-tile:nth-child(3n+3) {
   margin-right: 0;
 }


 .count {
   background: rgba(0,0,0,.25);
   padding: 5px;
   min-width: 25px;
   text-align: center;
 }
</style>


